import {Component, OnInit} from '@angular/core';
import {SharedService} from '../../services/shared.service';
import {CustomerService} from '../../services/customer.service';
import {MatDialogRef} from '@angular/material';
import {PHONE_MASK, PHONE_PATTERN} from '../../global';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  phone: string;
  showLoader: boolean;
  showSentForgotRequest: boolean;
  phoneMask = PHONE_MASK;
  validPhone: boolean;

  constructor(public dialogRef: MatDialogRef<ForgotPasswordComponent>,
              private customerService: CustomerService,
              private shared: SharedService) {
  }

  ngOnInit() {
  }

  forgotPassword(phone: string) {
    this.showLoader = true;
    phone = phone.match(/\d/g).join('');

    this.customerService.getCustomerByPhone(phone)
      .then(customer => {
        if (customer && customer.email) return this.customerService.forgotPasswordRequest(customer.uid);
        else return Promise.reject({errorMessage: 'Customer not registered'});
      })
      .then(res => {
        this.showSentForgotRequest = true;
        this.showLoader = false;
      })
      .catch(err => {
        this.showLoader = false;
        this.shared.openErrorDialog({title: 'Error', body: err.errorMessage || 'Unexpected error. Please try again'});
      });
  }

  phoneChange(phone: string) {
    let phoneRegex = new RegExp(PHONE_PATTERN);
    this.validPhone = phoneRegex.test(phone);
  }

  // this.customerService.getCurrentCustomer(true)
  //   .then(customer => {
  //     return this.customerService.forgotPasswordRequest(customer.uid);
  //   })
  //   .then(res => {
  //     this.showLoader = false;
  //     this.showSentForgotRequest = true;
  //   })
  //   .catch(_ => {
  //     this.shared.openErrorDialog({title: 'Error', body: 'Unexpected error. Please try again'});
  //   });

}
